import React from 'react'
import {PageProps} from "gatsby";
import {MDXRenderer} from "gatsby-plugin-mdx";
import NewsPage from "../../layout/NewsPage";

export default ({data}: PageProps<GatsbyTypes.NewsItemPageQuery>) => {
    if(!data?.newsPost)
        return <p>No content</p>

    const {title, body, author, date} = data.newsPost

    return <NewsPage title={title} author={author} date={date}>
        {body ? <MDXRenderer>{body}</MDXRenderer> : undefined}
    </NewsPage>
}